'use client';

import React, { FC, PropsWithChildren, useEffect } from 'react';
import { devLog } from '@/utils/dev';
import { clearOldCaches } from './cache.utils';

let timeId: number = 0;
const CacheContainer: FC<PropsWithChildren<{}>> = ({ children }) => {
  useEffect(() => {
    if (typeof window.caches !== 'undefined') {
      timeId = window.setInterval(async () => {
        const oldCacheNames = await clearOldCaches();
        if (!oldCacheNames.length) clearInterval(timeId);
        devLog('@cache@oldNames', oldCacheNames);
      }, 3000);
    }
  }, []);

  return <>{children}</>;
};

export default CacheContainer;
